import React from "react";

const InsuranceProtectStats = ({
  loading = false,
  totalPolicies,
  paid,
  awaitingPayment,
  totalBilled,
  needsOpsAction,
}) => {
  // While loading, show "…" instead of zeros.
  const show = (value) => (loading ? "…" : value);

  return (
    <div className="ip-stats-row">
      <div className="ip-stat-card">
        <div className="ip-stat-label">Total Policies</div>
        <div className="ip-stat-value">{show(totalPolicies)}</div>
      </div>
      <div className="ip-stat-card">
        <div className="ip-stat-label">Paid</div>
        <div className="ip-stat-value">{show(paid)}</div>
      </div>
      <div className="ip-stat-card">
        <div className="ip-stat-label">Awaiting Payment</div>
        <div className="ip-stat-value">{show(awaitingPayment)}</div>
      </div>
      <div className="ip-stat-card">
        <div className="ip-stat-label">Total Billed</div>
        <div className="ip-stat-value">
          {loading
            ? "…"
            : `€ ${Number(totalBilled || 0).toLocaleString("es-ES", {
                minimumFractionDigits: 2,
                maximumFractionDigits: 2,
              })}`}
        </div>
      </div>
      <div className="ip-stat-card ip-stat-card-ops">
        <div className="ip-stat-label">Needs Ops Action</div>
        <div className="ip-stat-value">{show(needsOpsAction)}</div>
      </div>
    </div>
  );
};

export default InsuranceProtectStats;
